import React from 'react'
import Accordions from '../../../components/Accordions'


const Sem2Csd1 = () => {
  const data = [
    {
      subjectName: "2023 Batch",
      units: [ ],
      links: [
        {
          url: "https://drive.google.com/file/d/12UfYp_aYrbcd39L00oMEzJb7CvP5CHRx/view?usp=sharing",
          title: "Syllabus",
        },
      ],
    },
    {
      subjectName: "2024 Batch",
      units: [],
      links: [
        {
          url: "https://drive.google.com/file/d/1lN7V0ISh-PN9Dm5jXRu7dzhzxrAoT5G9/view?usp=drive_link",
          title: "Syllabus",
        },
      ],
    },
            {
      subjectName: "2025 Batch",
      units: [ ],
      links: [
        {
          url: "https://www.sonatech.ac.in/academics/syllabus/B.E-B.Tech/2025-Batch/CSD-1-2%20Sem-Curriculum-Syllabus.pdf",
          title: "Syllabus",
        },
      ],
    },
    ];
  return (
    <div className="min-h-screen pt-12 m-auto w-[90%]">
      <h1 className="text-xl font-semibold flex justify-center">CSD Sem - 2</h1>
      <Accordions data={data} />
    </div>
  );
};

export default Sem2Csd1